import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { Track } from '@platzi/commons';
import { BasicTooltip } from '@platzi/ui';
import { getFollowSchools, followSchool } from 'src/api';
import styles from './AddRouteButton.module.sass';

export const AddRouteButton = (props) => {
  const { t } = useTranslation();
  const routeId = useSelector((state) => state.get('route').get('id')) || 0;
  const [isTooltipActive, setIsTooltipActive] = useState(false);

  useEffect(() => {
    getFollowSchools()
      .then((res) => {
        const isFollowing = res.data?.filter((item) => item.learningPathId === routeId);

        if (isFollowing.length > 0) {
          props.setUserFollowSchool(true);
        } else {
          props.setUserFollowSchool(false);
        }
      })
      .catch((err) => {
        throw new Error('::ERROR::GET_ROUTES_ADD-ROUTE-BUTTON', { cause: err });
      });
  }, []);

  const handleFollow = () => {
    props.setUserFollowSchool(true);
    followSchool(routeId, { level: 'basic' })
      .then(() => Track.send({ ...props.recordFollowRoute }))
      .catch((err) => {
        throw new Error('::ERROR::FOLLOW_ROUTES_ADD-ROUTE-BUTTON', { cause: err });
      });
  };

  const handleTooltipInteraction = () => {
    setIsTooltipActive(!isTooltipActive);
  };

  if (props.userFollowSchool === undefined) {
    return <span className={styles.Empty} />;
  }

  if (props.userFollowSchool) {
    return (
      <div className={styles.ButtonAddedCont}>
        <button
          className={styles.Added}
          onClick={() => props.setShowModal(true)}
          onMouseEnter={handleTooltipInteraction}
          onMouseLeave={handleTooltipInteraction}
        >
          <FontAwesomeIcon icon={faCircleCheck} />

          {t('route.addRouteButton.added')}
        </button>
        <BasicTooltip isActive={isTooltipActive} position={'top'} styles={{ width: '100%' }}>
          {t('route.addRouteButton.unfollowRoute')}
        </BasicTooltip>
      </div>
    );
  }

  return (
    <button type="button" onClick={handleFollow} className={styles.AddRouteButton}>
      <FontAwesomeIcon icon={faCirclePlus} />
      {t('route.addRouteButton.add')}
    </button>
  );
};
